
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
// This component wraps each child component in a div that handles styling when
// selected and emits a "select" event

export default {
  name: 'NsSlottedDropdownItems',
  props: {
    dense: Boolean,
    modal: Boolean,
    selected: {
      type: [String, Number],
      default: null,
    },
    showAll: Boolean,
    usingCustom: Boolean,
  },
  methods: {
    handleClick(e, index) {
      e.stopPropagation();
      const vNode = this.$slots.default[index];
      const value = vNode.data.attrs['data-value'] || index;
      this.$emit('select', value, index);
    },
    isSelected(index) {
      const vNode = this.$slots.default[index];
      const value = vNode.data.attrs['data-value'];

      if (value) {
        return this.usingCustom
          ? value === 'custom'
          : String(this.selected) === String(value);
      } else {
        return this.selected === index;
      }
    },
  },
  render(createElement) {
    if (!this.$slots.default) {
      return null;
    }

    return createElement(
      'div',
      {
        class: [
          this.$style.container,
          {
            [this.$style.showAll]: this.showAll,
            [this.$style.modal]: this.modal,
          },
        ],
      },
      this.$slots.default.map((child, index) =>
        createElement(
          'div',
          {
            class: [
              this.$style.item,
              {
                [this.$style.selected]: this.isSelected(index),
                [this.$style.dense]: this.dense,
              },
            ],
            on: {
              click: (e) => this.handleClick(e, index),
            },
            ref: `item-${index}`,
          },
          [child]
        )
      )
    );
  },
};
